import { render } from "./QuangTri.vue?vue&type=template&id=06ba5d6c&scoped=true"
import script from "./QuangTri.vue?vue&type=script&lang=js"
export * from "./QuangTri.vue?vue&type=script&lang=js"

import "./QuangTri.vue?vue&type=style&index=0&id=06ba5d6c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ba5d6c"]])

export default __exports__